"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const SvgIcon_vue_1 = __importDefault(require("../SvgIcon/SvgIcon.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ValidationText',
    props: {
        errorMessage: {},
        noIndent: { type: Boolean },
        dataTestName: {}
    },
    setup(__props) {
        const props = __props;
        const dataTestErrorName = (0, vue_3.computed)(() => (props.dataTestName ? `${props.dataTestName}-error` : ""));
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", (0, vue_2.normalizeProps)({
                class: ["flex items-center pt-1 text-xs text-error", { 'pl-4': !_ctx.noIndent }],
                [dataTestErrorName.value || ""]: '',
                "aria-live": "polite"
            }), [
                (_ctx.errorMessage?.trim())
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgIcon_vue_1.default, {
                        key: 0,
                        "icon-name": "error",
                        title: "Fehler:",
                        class: "mr-1 size-4 shrink-0"
                    }))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.errorMessage), 1)
            ], 16));
        };
    }
});
